/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Statuses_WontfixInputs */

const es_feedback_statuses_wontfix = /** @type {(inputs: Feedback_Statuses_WontfixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se resolverá`)
};

const en_feedback_statuses_wontfix = /** @type {(inputs: Feedback_Statuses_WontfixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Won't Fix`)
};

/**
* | output |
* | --- |
* | "Won't Fix" |
*
* @param {Feedback_Statuses_WontfixInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_statuses_wontfix = /** @type {((inputs?: Feedback_Statuses_WontfixInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Statuses_WontfixInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_statuses_wontfix(inputs)
	return en_feedback_statuses_wontfix(inputs)
});
export { feedback_statuses_wontfix as "feedback.statuses.wontfix" }